import { render, staticRenderFns } from "./MoneyTransfer.vue?vue&type=template&id=d7efd4d4&"
import script from "./MoneyTransfer.vue?vue&type=script&lang=js&"
export * from "./MoneyTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports